/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetProduct200ResponseData
 */
export interface GetProduct200ResponseData {
  /**
   *
   * @type {number}
   * @memberof GetProduct200ResponseData
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof GetProduct200ResponseData
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof GetProduct200ResponseData
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetProduct200ResponseData
   */
  description?: string | null
  /**
   *
   * @type {number}
   * @memberof GetProduct200ResponseData
   */
  count?: number
  /**
   *
   * @type {boolean}
   * @memberof GetProduct200ResponseData
   */
  noDiscount?: boolean
  /**
   *
   * @type {boolean}
   * @memberof GetProduct200ResponseData
   */
  fiscalization?: boolean
  /**
   *
   * @type {boolean}
   * @memberof GetProduct200ResponseData
   */
  isTransit?: boolean
  /**
   *
   * @type {boolean}
   * @memberof GetProduct200ResponseData
   */
  active: boolean
  /**
   *
   * @type {number}
   * @memberof GetProduct200ResponseData
   */
  parentId?: number | null
  /**
   * Цены продукта с валютами (id, productId, price, currency); в ответе этого эндпоинта всегда null — аппенды модели не включаются
   * @type {Array<object>}
   * @memberof GetProduct200ResponseData
   */
  prices?: Array<object>
  /**
   * Дочерние продукты (структура повторяет сам продукт); в ответе этого эндпоинта всегда null — аппенды модели не включаются
   * @type {Array<object>}
   * @memberof GetProduct200ResponseData
   */
  children?: Array<object>
}

/**
 * Check if a given object implements the GetProduct200ResponseData interface.
 */
export function instanceOfGetProduct200ResponseData(
  value: object
): value is GetProduct200ResponseData {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('active' in value) || value['active'] === undefined) return false
  return true
}

export function GetProduct200ResponseDataFromJSON(
  json: any
): GetProduct200ResponseData {
  return GetProduct200ResponseDataFromJSONTyped(json, false)
}

export function GetProduct200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetProduct200ResponseData {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    title: json['title'],
    description: json['description'] == null ? undefined : json['description'],
    count: json['count'] == null ? undefined : json['count'],
    noDiscount: json['noDiscount'] == null ? undefined : json['noDiscount'],
    fiscalization:
      json['fiscalization'] == null ? undefined : json['fiscalization'],
    isTransit: json['isTransit'] == null ? undefined : json['isTransit'],
    active: json['active'],
    parentId: json['parentId'] == null ? undefined : json['parentId'],
    prices: json['prices'] == null ? undefined : json['prices'],
    children: json['children'] == null ? undefined : json['children'],
  }
}

export function GetProduct200ResponseDataToJSON(
  value?: GetProduct200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    name: value['name'],
    title: value['title'],
    description: value['description'],
    count: value['count'],
    noDiscount: value['noDiscount'],
    fiscalization: value['fiscalization'],
    isTransit: value['isTransit'],
    active: value['active'],
    parentId: value['parentId'],
    prices: value['prices'],
    children: value['children'],
  }
}
